export default __webpack_public_path__ + "static/media/apps.432d2d90.svg";